/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Ui_Effort_Steady_LabelInputs */

const en_ui_effort_steady_label = /** @type {(inputs: Ui_Effort_Steady_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Steady ${i?.number}`)
};

const de_ui_effort_steady_label = /** @type {(inputs: Ui_Effort_Steady_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gleichmäßig ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Steady {number}" |
*
* @param {Ui_Effort_Steady_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_effort_steady_label = /** @type {((inputs: Ui_Effort_Steady_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Effort_Steady_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_effort_steady_label(inputs)
	return de_ui_effort_steady_label(inputs)
});